{
    "cs": {
        "Yes": "Ano",
        "No": "Ne",
        "Cancel": "Zrušit",
        "Close": "Zavřít",
        "Clear": "Smazat",
        "Done": "Hotovo",
        "Loading": "Nahrávání...",
        "Select": "Výběr...",
        "Search": "Hledat",
        "Back": "Zpět",
        "OK": "OK",

        "dxCollectionWidget-noDataText": "Žádná data k zobrazení",

        "dxDropDownEditor-selectLabel": "Výběr",

        "validation-required": "povinné",
        "validation-required-formatted": "{0} je povinných",
        "validation-numeric": "Hodnota musí být číslo",
        "validation-numeric-formatted": "{0} musí být číslo",
        "validation-range": "Hodnota je mimo rozsah",
        "validation-range-formatted": "{0} je mimo rozsah",
        "validation-stringLength": "Délka textového řetezce není správná",
        "validation-stringLength-formatted": "Délka textu {0} není správná",
        "validation-custom": "Neplatná hodnota",
        "validation-custom-formatted": "{0} je neplatných",
        "validation-async": "Neplatná hodnota",
        "validation-async-formatted": "{0} je neplatných",
        "validation-compare": "Hodnoty se neshodují",
        "validation-compare-formatted": "{0} se neshoduje",
        "validation-pattern": "Hodnota neodpovídá vzoru",
        "validation-pattern-formatted": "{0} neodpovídá vzoru",
        "validation-email": "Neplatný email",
        "validation-email-formatted": "{0} není platný",
        "validation-mask": "Hodnota není platná",

        "dxLookup-searchPlaceholder": "Minimální počet znaků: {0}",

        "dxList-pullingDownText": "Stáhněte dolů pro obnovení...",
        "dxList-pulledDownText": "Uvolněte pro obnovení...",
        "dxList-refreshingText": "Obnovuji...",
        "dxList-pageLoadingText": "Nahrávám...",
        "dxList-nextButtonText": "Více",
        "dxList-selectAll": "Vybrat vše",
        "dxListEditDecorator-delete": "Smazat",
        "dxListEditDecorator-more": "Více",

        "dxScrollView-pullingDownText": "Stáhněte dolů pro obnovení...",
        "dxScrollView-pulledDownText": "Uvolněte pro obnovení...",
        "dxScrollView-refreshingText": "Obnovuji...",
        "dxScrollView-reachBottomText": "Nahrávám...",

        "dxDateBox-simulatedDataPickerTitleTime": "Vyberte čas",
        "dxDateBox-simulatedDataPickerTitleDate": "Vyberte datum",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Vyberte datum a čas",
        "dxDateBox-validation-datetime": "Hodnota musí být datum nebo čas",

        "dxDateRangeBox-invalidStartDateMessage": "Start value must be a date",
        "dxDateRangeBox-invalidEndDateMessage": "End value must be a date",
        "dxDateRangeBox-startDateOutOfRangeMessage": "Start date is out of range",
        "dxDateRangeBox-endDateOutOfRangeMessage": "End date is out of range",
        "dxDateRangeBox-startDateLabel": "Počáteční datum",
        "dxDateRangeBox-endDateLabel": "Koncové datum",

        "dxFileUploader-selectFile": "Vyberte soubor",
        "dxFileUploader-dropFile": "nebo přeneste soubor sem",
        "dxFileUploader-bytes": "bytů",
        "dxFileUploader-kb": "KB",
        "dxFileUploader-Mb": "MB",
        "dxFileUploader-Gb": "GB",
        "dxFileUploader-upload": "Nahrát",
        "dxFileUploader-uploaded": "Nahráno",
        "dxFileUploader-readyToUpload": "Připraveno k nahrání",
        "dxFileUploader-uploadAbortedMessage": "Nahrávání zrušeno",
        "dxFileUploader-uploadFailedMessage": "Nahrávání selhalo",
        "dxFileUploader-invalidFileExtension": "Nepovolený typ souboru",
        "dxFileUploader-invalidMaxFileSize": "Soubor je příliš velký",
        "dxFileUploader-invalidMinFileSize": "Soubor je příliš malý",

        "dxRangeSlider-ariaFrom": "Od",
        "dxRangeSlider-ariaTill": "Do",
        "dxSwitch-switchedOnText": "ZAP",
        "dxSwitch-switchedOffText": "VYP",

        "dxForm-optionalMark": "volitelný",
        "dxForm-requiredMessage": "{0} je vyžadováno",

        "dxNumberBox-invalidValueMessage": "Hodnota musí být číslo",
        "dxNumberBox-noDataText": "Žádná data",

        "dxDataGrid-emptyHeaderWithColumnChooserText": "Use {0} to display columns",
        "dxDataGrid-emptyHeaderWithGroupPanelText": "Drag a column from the group panel here",
        "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Use {0} or drag a column from the group panel",
        "dxDataGrid-emptyHeaderColumnChooserText": "column chooser",
        "dxDataGrid-columnChooserTitle": "Výběr sloupců",
        "dxDataGrid-columnChooserEmptyText": "Přesuňte sloupec zde pro skytí",
        "dxDataGrid-groupContinuesMessage": "Pokračovat na další straně",
        "dxDataGrid-groupContinuedMessage": "Pokračování z předchozí strany",
        "dxDataGrid-groupHeaderText": "Sloučit sloupce",
        "dxDataGrid-ungroupHeaderText": "Oddělit",
        "dxDataGrid-ungroupAllText": "Oddělit vše",
        "dxDataGrid-editingEditRow": "Upravit",
        "dxDataGrid-editingSaveRowChanges": "Uložit",
        "dxDataGrid-editingCancelRowChanges": "Zrušit",
        "dxDataGrid-editingDeleteRow": "Smazat",
        "dxDataGrid-editingUndeleteRow": "Obnovit",
        "dxDataGrid-editingConfirmDeleteMessage": "Opravdu chcete smazat tento záznam?",
        "dxDataGrid-validationCancelChanges": "Zrušit změny",
        "dxDataGrid-groupPanelEmptyText": "Přeneste hlavičku sloupce zde pro sloučení",
        "dxDataGrid-noDataText": "Žádná data",
        "dxDataGrid-searchPanelPlaceholder": "Hledání...",
        "dxDataGrid-filterRowShowAllText": "(Vše)",
        "dxDataGrid-filterRowResetOperationText": "Reset",
        "dxDataGrid-filterRowOperationEquals": "Rovná se",
        "dxDataGrid-filterRowOperationNotEquals": "Nerovná se",
        "dxDataGrid-filterRowOperationLess": "Menší",
        "dxDataGrid-filterRowOperationLessOrEquals": "Menší nebo rovno",
        "dxDataGrid-filterRowOperationGreater": "Větší",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Větší nebo rovno",
        "dxDataGrid-filterRowOperationStartsWith": "Začíná na",
        "dxDataGrid-filterRowOperationContains": "Obsahuje",
        "dxDataGrid-filterRowOperationNotContains": "Neobsahuje",
        "dxDataGrid-filterRowOperationEndsWith": "Končí na",
        "dxDataGrid-filterRowOperationBetween": "Mezi",
        "dxDataGrid-filterRowOperationBetweenStartText": "Začíná",
        "dxDataGrid-filterRowOperationBetweenEndText": "Končí",
        "dxDataGrid-ariaSearchBox": "Search box",
        "dxDataGrid-applyFilterText": "Použít filtr",
        "dxDataGrid-trueText": "Platí",
        "dxDataGrid-falseText": "Neplatí",
        "dxDataGrid-sortingAscendingText": "Srovnat vzestupně",
        "dxDataGrid-sortingDescendingText": "Srovnat sestupně",
        "dxDataGrid-sortingClearText": "Zrušit rovnání",
        "dxDataGrid-ariaNotSortedColumn": "Not sorted column",
        "dxDataGrid-ariaSortedAscendingColumn": "Column sorted in ascending order",
        "dxDataGrid-ariaSortedDescendingColumn": "Column sorted in descending order",
        "dxDataGrid-ariaSortIndex": "Sort index {0}",
        "dxDataGrid-editingSaveAllChanges": "Uložit změny",
        "dxDataGrid-editingCancelAllChanges": "Zrušit změny",
        "dxDataGrid-editingAddRow": "Přidat řádek",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Min {1} je {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Max {1} je {0}",
        "dxDataGrid-summaryAvg": "Prům.: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Průměr ze {1} je {0}",
        "dxDataGrid-summarySum": "Suma: {0}",
        "dxDataGrid-summarySumOtherColumn": "Suma {1} je {0}",
        "dxDataGrid-summaryCount": "Počet: {0}",
        "dxDataGrid-columnFixingFix": "Uchytit",
        "dxDataGrid-columnFixingUnfix": "Uvolnit",
        "dxDataGrid-columnFixingLeftPosition": "Vlevo",
        "dxDataGrid-columnFixingRightPosition": "Vpravo",
        "dxDataGrid-exportTo": "Export",
        "dxDataGrid-exportToExcel": "Export do sešitu Excel",
        "dxDataGrid-exporting": "Export...",
        "dxDataGrid-excelFormat": "soubor Excel",
        "dxDataGrid-selectedRows": "Vybrané řádky",
        "dxDataGrid-exportSelectedRows": "Export vybraných řádků",
        "dxDataGrid-exportAll": "Exportovat všechny záznamy",
        "dxDataGrid-headerFilterLabel": "Filter options",
        "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
        "dxDataGrid-headerFilterEmptyValue": "(prázdné)",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "Zrušit",
        "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
        "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
        "dxDataGrid-ariaColumn": "Sloupec",
        "dxDataGrid-ariaColumnHeader": "Column header",
        "dxDataGrid-ariaValue": "Hodnota",
        "dxDataGrid-ariaError": "Error",
        "dxDataGrid-ariaRevertButton": "Press Escape to discard the changes",
        "dxDataGrid-ariaFilterCell": "Filtrovat buňku",
        "dxDataGrid-ariaCollapse": "Sbalit",
        "dxDataGrid-ariaModifiedCell": "Modified",
        "dxDataGrid-ariaDeletedCell": "Deleted",
        "dxDataGrid-ariaEditableCell": "Editable",
        "dxDataGrid-ariaExpand": "Rozbalit",
        "dxDataGrid-ariaCollapsedRow": "Collapsed row",
        "dxDataGrid-ariaExpandedRow": "Expanded row",
        "dxDataGrid-ariaDataGrid": "Datová mřížka",
        "dxDataGrid-ariaSearchInGrid": "Hledat v datové mřížce",
        "dxDataGrid-ariaSelectAll": "Vybrat vše",
        "dxDataGrid-ariaSelectRow": "Vybrat řádek",
        "dxDataGrid-ariaToolbar": "Data grid toolbar",
        "dxDataGrid-ariaEditForm": "Edit form",
        "dxDataGrid-filterBuilderPopupTitle": "Tvorba Filtru",
        "dxDataGrid-filterPanelCreateFilter": "Vytvořit Filtr",
        "dxDataGrid-filterPanelClearFilter": "Smazat",
        "dxDataGrid-filterPanelFilterEnabledHint": "Povolit Filtr",

        "dxTreeList-ariaTreeList": "Tree list with {0} rows and {1} columns",
        "dxTreeList-ariaSearchInGrid": "Search in the tree list",
        "dxTreeList-ariaToolbar": "Tree list toolbar",
        "dxTreeList-editingAddRowToNode": "Přidat",

        "dxPager-infoText": "Strana {0} ze {1} ({2} položek)",
        "dxPager-pagesCountText": "ze",
        "dxPager-pageSize": "Items per page: {0}",
        "dxPager-pageSizesAllText": "Vše",
        "dxPager-page": "Page {0}",
        "dxPager-prevPage": "Previous Page",
        "dxPager-nextPage": "Next Page",
        "dxPager-ariaLabel": "Page Navigation",
        "dxPager-ariaPageSize": "Page size",
        "dxPager-ariaPageNumber": "Page number",

        "dxPivotGrid-grandTotal": "Celkem",
        "dxPivotGrid-total": "{0} Celkem",
        "dxPivotGrid-fieldChooserTitle": "Výběr pole",
        "dxPivotGrid-showFieldChooser": "Zobrazit výběr pole",
        "dxPivotGrid-expandAll": "Rozbalit vše",
        "dxPivotGrid-collapseAll": "Sbalit vše",
        "dxPivotGrid-sortColumnBySummary": "Srovnat \"{0}\" podle tohoto sloupce",
        "dxPivotGrid-sortRowBySummary": "Srovnat \"{0}\" podle tohoto řádku",
        "dxPivotGrid-removeAllSorting": "Odstranit veškeré třídění",
        "dxPivotGrid-dataNotAvailable": "nedostupné",
        "dxPivotGrid-rowFields": "Pole řádků",
        "dxPivotGrid-columnFields": "Pole sloupců",
        "dxPivotGrid-dataFields": "Pole dat",
        "dxPivotGrid-filterFields": "Filtrovat pole",
        "dxPivotGrid-allFields": "Všechna pole",
        "dxPivotGrid-columnFieldArea": "Zde vložte pole sloupců",
        "dxPivotGrid-dataFieldArea": "Zde vložte pole dat",
        "dxPivotGrid-rowFieldArea": "Zde vložte pole řádků",
        "dxPivotGrid-filterFieldArea": "Zde vložte filtr pole",

        "dxScheduler-editorLabelTitle": "Předmět",
        "dxScheduler-editorLabelStartDate": "Počáteční datum",
        "dxScheduler-editorLabelEndDate": "Koncové datum",
        "dxScheduler-editorLabelDescription": "Popis",
        "dxScheduler-editorLabelRecurrence": "Opakovat",

        "dxScheduler-openAppointment": "Otevřít schůzku",

        "dxScheduler-recurrenceNever": "Nikdy",
        "dxScheduler-recurrenceMinutely": "Minutově",
        "dxScheduler-recurrenceHourly": "Hodinově",
        "dxScheduler-recurrenceDaily": "Denně",
        "dxScheduler-recurrenceWeekly": "Týdně",
        "dxScheduler-recurrenceMonthly": "Měsíčně",
        "dxScheduler-recurrenceYearly": "Ročně",

        "dxScheduler-recurrenceRepeatEvery": "Každý",
        "dxScheduler-recurrenceRepeatOn": "Začátek opakování",
        "dxScheduler-recurrenceEnd": "Konec opakování",
        "dxScheduler-recurrenceAfter": "Po",
        "dxScheduler-recurrenceOn": "Zap",

        "dxScheduler-recurrenceRepeatMinutely": "minut(u)",
        "dxScheduler-recurrenceRepeatHourly": "hodin(u)",
        "dxScheduler-recurrenceRepeatDaily": "dní",
        "dxScheduler-recurrenceRepeatWeekly": "týdnů",
        "dxScheduler-recurrenceRepeatMonthly": "měsíců",
        "dxScheduler-recurrenceRepeatYearly": "roků",

        "dxScheduler-switcherDay": "Den",
        "dxScheduler-switcherWeek": "Týden",
        "dxScheduler-switcherWorkWeek": "Pracovní týden",
        "dxScheduler-switcherMonth": "Měsíc",

        "dxScheduler-switcherAgenda": "Agenda",

        "dxScheduler-switcherTimelineDay": "Časová osa den",
        "dxScheduler-switcherTimelineWeek": "Časová osa týden",
        "dxScheduler-switcherTimelineWorkWeek": "Časová osa pracovní týden",
        "dxScheduler-switcherTimelineMonth": "Časová osa měsíc",

        "dxScheduler-recurrenceRepeatOnDate": "na den",
        "dxScheduler-recurrenceRepeatCount": "výskytů",
        "dxScheduler-allDay": "Celý den",

        "dxScheduler-confirmRecurrenceEditTitle": "Edit Recurring Appointment",
        "dxScheduler-confirmRecurrenceDeleteTitle": "Delete Recurring Appointment",

        "dxScheduler-confirmRecurrenceEditMessage": "Chcete upravit pouze tuto schůzku nebo celou sérii?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Chcete smazat pouze tuto schůzku nebo celou sérii?",

        "dxScheduler-confirmRecurrenceEditSeries": "Upravit sérii",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Smazat sérii",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Upravit schůzku",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Smazat schůzku",

        "dxScheduler-noTimezoneTitle": "Bez časové zóny",
        "dxScheduler-moreAppointments": "{0} navíc",

        "dxCalendar-todayButtonText": "Dnes",
        "dxCalendar-ariaWidgetName": "Kalendář",
        "dxCalendar-previousMonthButtonLabel": "Previous month",
        "dxCalendar-previousYearButtonLabel": "Previous year",
        "dxCalendar-previousDecadeButtonLabel": "Previous decade",
        "dxCalendar-previousCenturyButtonLabel": "Previous century",
        "dxCalendar-nextMonthButtonLabel": "Next month",
        "dxCalendar-nextYearButtonLabel": "Next year",
        "dxCalendar-nextDecadeButtonLabel": "Next decade",
        "dxCalendar-nextCenturyButtonLabel": "Next century",
        "dxCalendar-captionMonthLabel": "Month selection",
        "dxCalendar-captionYearLabel": "Year selection",
        "dxCalendar-captionDecadeLabel": "Decade selection",
        "dxCalendar-captionCenturyLabel": "Century selection",

        "dxColorView-ariaRed": "Červená",
        "dxColorView-ariaGreen": "Zelená",
        "dxColorView-ariaBlue": "Modrá",
        "dxColorView-ariaAlpha": "Průhledná",
        "dxColorView-ariaHex": "Kód barvy",

        "dxTagBox-selected": "{0} vybráno",
        "dxTagBox-allSelected": "Vše vybráno ({0})",
        "dxTagBox-moreSelected": "{0} navíc",

        "vizExport-printingButtonText": "Tisk",
        "vizExport-titleMenuText": "Export/import",
        "vizExport-exportButtonText": "{0} souborů",

        "dxFilterBuilder-and": "A",
        "dxFilterBuilder-or": "NEBO",
        "dxFilterBuilder-notAnd": "NAND",
        "dxFilterBuilder-notOr": "NOR",
        "dxFilterBuilder-addCondition": "Přidat podmínku",
        "dxFilterBuilder-addGroup": "Přidat skupinu",
        "dxFilterBuilder-enterValueText": "<vložte hodnotu>",
        "dxFilterBuilder-filterOperationEquals": "Rovná se",
        "dxFilterBuilder-filterOperationNotEquals": "Nerovná se",
        "dxFilterBuilder-filterOperationLess": "Menší než",
        "dxFilterBuilder-filterOperationLessOrEquals": "Menší nebo rovno než",
        "dxFilterBuilder-filterOperationGreater": "Větší než",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Větší nebo rovno než",
        "dxFilterBuilder-filterOperationStartsWith": "Začíná na",
        "dxFilterBuilder-filterOperationContains": "Obsahuje",
        "dxFilterBuilder-filterOperationNotContains": "Neobsahuje",
        "dxFilterBuilder-filterOperationEndsWith": "Končí na",
        "dxFilterBuilder-filterOperationIsBlank": "Je prázdné",
        "dxFilterBuilder-filterOperationIsNotBlank": "Není prázdné",
        "dxFilterBuilder-filterOperationBetween": "Mezi",
        "dxFilterBuilder-filterOperationAnyOf": "Libovolný z",
        "dxFilterBuilder-filterOperationNoneOf": "Žádný z",

        "dxHtmlEditor-dialogColorCaption": "Změna barvy písma",
        "dxHtmlEditor-dialogBackgroundCaption": "Změna barvy pozadí",
        "dxHtmlEditor-dialogLinkCaption": "Vložit odkaz",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Text",
        "dxHtmlEditor-dialogLinkTargetField": "Otevřít odkaz v novém okně",
        "dxHtmlEditor-dialogImageCaption": "Vložit obrázek",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Alternativní text",
        "dxHtmlEditor-dialogImageWidthField": "Šířka (px)",
        "dxHtmlEditor-dialogImageHeightField": "Výška (px)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Řádků",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Sloupců",
        "dxHtmlEditor-dialogInsertTableCaption": "Vložit tabulku",
        "dxHtmlEditor-dialogUpdateImageCaption": "Update Image",
        "dxHtmlEditor-dialogImageUpdateButton": "Update",
        "dxHtmlEditor-dialogImageAddButton": "Add",
        "dxHtmlEditor-dialogImageSpecifyUrl": "From the Web",
        "dxHtmlEditor-dialogImageSelectFile": "From This Device",
        "dxHtmlEditor-dialogImageKeepAspectRatio": "Keep Aspect Ratio",
        "dxHtmlEditor-dialogImageEncodeToBase64": "Encode to Base64",
        "dxHtmlEditor-heading": "Nadpis",
        "dxHtmlEditor-normalText": "Normální text",
        "dxHtmlEditor-background": "Background Color",
        "dxHtmlEditor-bold": "Bold",
        "dxHtmlEditor-color": "Font Color",
        "dxHtmlEditor-font": "Font",
        "dxHtmlEditor-italic": "Italic",
        "dxHtmlEditor-link": "Add Link",
        "dxHtmlEditor-image": "Add Image",
        "dxHtmlEditor-size": "Size",
        "dxHtmlEditor-strike": "Strikethrough",
        "dxHtmlEditor-subscript": "Subscript",
        "dxHtmlEditor-superscript": "Superscript",
        "dxHtmlEditor-underline": "Underline",
        "dxHtmlEditor-blockquote": "Blockquote",
        "dxHtmlEditor-header": "Header",
        "dxHtmlEditor-increaseIndent": "Increase Indent",
        "dxHtmlEditor-decreaseIndent": "Decrease Indent",
        "dxHtmlEditor-orderedList": "Ordered List",
        "dxHtmlEditor-bulletList": "Bullet List",
        "dxHtmlEditor-alignLeft": "Align Left",
        "dxHtmlEditor-alignCenter": "Align Center",
        "dxHtmlEditor-alignRight": "Align Right",
        "dxHtmlEditor-alignJustify": "Align Justify",
        "dxHtmlEditor-codeBlock": "Code Block",
        "dxHtmlEditor-variable": "Add Variable",
        "dxHtmlEditor-undo": "Undo",
        "dxHtmlEditor-redo": "Redo",
        "dxHtmlEditor-clear": "Clear Formatting",
        "dxHtmlEditor-insertTable": "Insert Table",
        "dxHtmlEditor-insertHeaderRow": "Insert Header Row",
        "dxHtmlEditor-insertRowAbove": "Insert Row Above",
        "dxHtmlEditor-insertRowBelow": "Insert Row Below",
        "dxHtmlEditor-insertColumnLeft": "Insert Column Left",
        "dxHtmlEditor-insertColumnRight": "Insert Column Right",
        "dxHtmlEditor-deleteColumn": "Delete Column",
        "dxHtmlEditor-deleteRow": "Delete Row",
        "dxHtmlEditor-deleteTable": "Delete Table",
        "dxHtmlEditor-cellProperties": "Cell Properties",
        "dxHtmlEditor-tableProperties": "Table Properties",
        "dxHtmlEditor-insert": "Insert",
        "dxHtmlEditor-delete": "Delete",
        "dxHtmlEditor-border": "Border",
        "dxHtmlEditor-style": "Style",
        "dxHtmlEditor-width": "Width",
        "dxHtmlEditor-height": "Height",
        "dxHtmlEditor-borderColor": "Color",
        "dxHtmlEditor-tableBackground": "Background",
        "dxHtmlEditor-dimensions": "Dimensions",
        "dxHtmlEditor-alignment": "Alignment",
        "dxHtmlEditor-horizontal": "Horizontal",
        "dxHtmlEditor-vertical": "Vertical",
        "dxHtmlEditor-paddingVertical": "Vertical Padding",
        "dxHtmlEditor-paddingHorizontal": "Horizontal Padding",
        "dxHtmlEditor-pixels": "Pixels",
        "dxHtmlEditor-list": "List",
        "dxHtmlEditor-ordered": "Ordered",
        "dxHtmlEditor-bullet": "Bullet",
        "dxHtmlEditor-align": "Align",
        "dxHtmlEditor-center": "Center",
        "dxHtmlEditor-left": "Left",
        "dxHtmlEditor-right": "Right",
        "dxHtmlEditor-indent": "Indent",
        "dxHtmlEditor-justify": "Justify",
        "dxHtmlEditor-borderStyleNone": "none",
        "dxHtmlEditor-borderStyleHidden": "hidden",
        "dxHtmlEditor-borderStyleDotted": "dotted",
        "dxHtmlEditor-borderStyleDashed": "dashed",
        "dxHtmlEditor-borderStyleSolid": "solid",
        "dxHtmlEditor-borderStyleDouble": "double",
        "dxHtmlEditor-borderStyleGroove": "groove",
        "dxHtmlEditor-borderStyleRidge": "ridge",
        "dxHtmlEditor-borderStyleInset": "inset",
        "dxHtmlEditor-borderStyleOutset": "outset",

        "dxFileManager-newDirectoryName": "Nepojmenovaná složka",
        "dxFileManager-rootDirectoryName": "Soubory",
        "dxFileManager-errorNoAccess": "Přístup zablokován. Operace nemůže být dokončena.",
        "dxFileManager-errorDirectoryExistsFormat": "Složka '{0}' již existuje.",
        "dxFileManager-errorFileExistsFormat": "Soubor '{0}' již existuje.",
        "dxFileManager-errorFileNotFoundFormat": "Soubor '{0}' nenalezen.",
        "dxFileManager-errorDirectoryNotFoundFormat": "Složka '{0}' nebyla nalezena.",
        "dxFileManager-errorWrongFileExtension": "Typ souboru není povolen. Zakázaná přípona",
        "dxFileManager-errorMaxFileSizeExceeded": "Soubor překročil maximální povolenou velikost.",
        "dxFileManager-errorInvalidSymbols": "Zadaný název obsahuje nepovolené znaky.",
        "dxFileManager-errorDefault": "Neznámá chyba.",
        "dxFileManager-errorDirectoryOpenFailed": "Nelze otevřít složku",

        "dxFileManager-commandCreate": "Nová složka",
        "dxFileManager-commandRename": "Přejmenovat",
        "dxFileManager-commandMove": "Přesunout",
        "dxFileManager-commandCopy": "Kopírovat",
        "dxFileManager-commandDelete": "Smazat",
        "dxFileManager-commandDownload": "Stáhnout",
        "dxFileManager-commandUpload": "Nahrát soubory",
        "dxFileManager-commandRefresh": "Obnovit",
        "dxFileManager-commandThumbnails": "Náhledy souborů",
        "dxFileManager-commandDetails": "Detailní přehled",
        "dxFileManager-commandClearSelection": "Zrušit výběr",
        "dxFileManager-commandShowNavPane": "Přepnout navigační panel",

        "dxFileManager-dialogDirectoryChooserMoveTitle": "Přesunout do",
        "dxFileManager-dialogDirectoryChooserMoveButtonText": "Přesunout",
        "dxFileManager-dialogDirectoryChooserCopyTitle": "Kopírovat do",
        "dxFileManager-dialogDirectoryChooserCopyButtonText": "Kopírovat",
        "dxFileManager-dialogRenameItemTitle": "Přejmenovat",
        "dxFileManager-dialogRenameItemButtonText": "Uložit",
        "dxFileManager-dialogCreateDirectoryTitle": "Nová složka",
        "dxFileManager-dialogCreateDirectoryButtonText": "Vytvořit",
        "dxFileManager-dialogDeleteItemTitle": "Odstranit",
        "dxFileManager-dialogDeleteItemButtonText": "Odstranit",
        "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Opravdu chcete odstranit {0}?",
        "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Opravdu chcete odstranit {0} položek?",
        "dxFileManager-dialogButtonCancel": "Storno",

        "dxFileManager-editingCreateSingleItemProcessingMessage": "Vytváří se složka v {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Vytvořena složka v {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "Složka nebyla vytvořena",
        "dxFileManager-editingCreateCommonErrorMessage": "Složka nebyla vytvořena",

        "dxFileManager-editingRenameSingleItemProcessingMessage": "Přejmenování položky v {0}",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Přejmenována položka v {0}",
        "dxFileManager-editingRenameSingleItemErrorMessage": "Položka nebyla přejmenována",
        "dxFileManager-editingRenameCommonErrorMessage": "Položka nebyla přejmenována",

        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Odstraňování položky z {0}",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Odstraňuje se {0} položek z {1}",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "Odstraněna položka z {0}",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Odstraňeno {0} položek z {1}",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "Položka nebyla odstraněna",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} položek nebylo odstraněno",
        "dxFileManager-editingDeleteCommonErrorMessage": "Některé z položek nebyly odstraněny",

        "dxFileManager-editingMoveSingleItemProcessingMessage": "Přesouvání položky do {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Přesouvání {0} položek do {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Položka přesunuta do {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Přesunuto {0} položek do {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "Položka nebyla přesunuta",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} položek nebylo přesunuto",
        "dxFileManager-editingMoveCommonErrorMessage": "Některé položky nebyly přesunuty",

        "dxFileManager-editingCopySingleItemProcessingMessage": "Kopírování položky do {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Kopírování {0} položek do {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Kopíruje se položka do {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Zkopírováno {0} položek do {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "Položka nebyla zkopírována",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} položek nebylo zkopírováno",
        "dxFileManager-editingCopyCommonErrorMessage": "Některé položky nebyly zkopírováný",

        "dxFileManager-editingUploadSingleItemProcessingMessage": "Nahrává se položka {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Náhrává se {0} položek do {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Položka nahrána do {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Nahráno {0} položek do {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "Položka nebyla nahrána",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} položek nebylo nahráno",
        "dxFileManager-editingUploadCanceledMessage": "Stornováno",

        "dxFileManager-editingDownloadSingleItemErrorMessage": "Item was not downloaded",
        "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} items were not downloaded",

        "dxFileManager-listDetailsColumnCaptionName": "Název",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Datum změny",
        "dxFileManager-listDetailsColumnCaptionFileSize": "Velikost souboru",

        "dxFileManager-listThumbnailsTooltipTextSize": "Velikost",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Datum změny",

        "dxFileManager-notificationProgressPanelTitle": "Průběh",
        "dxFileManager-notificationProgressPanelEmptyListText": "Žádná operace",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Stornováno",

        "dxDiagram-categoryGeneral": "Obecné",
        "dxDiagram-categoryFlowchart": "Flowchart",
        "dxDiagram-categoryOrgChart": "Organizační graf",
        "dxDiagram-categoryContainers": "Kontejnery",
        "dxDiagram-categoryCustom": "Vlastní",

        "dxDiagram-commandExportToSvg": "Export do SVG",
        "dxDiagram-commandExportToPng": "Export do PNG",
        "dxDiagram-commandExportToJpg": "Export do JPEG",
        "dxDiagram-commandUndo": "Zpět",
        "dxDiagram-commandRedo": "Znovu",
        "dxDiagram-commandFontName": "Písmo",
        "dxDiagram-commandFontSize": "Velikost písma",
        "dxDiagram-commandBold": "Tučné",
        "dxDiagram-commandItalic": "Kurzíva",
        "dxDiagram-commandUnderline": "Podtržené",
        "dxDiagram-commandTextColor": "Barva písma",
        "dxDiagram-commandLineColor": "Barva čáry",
        "dxDiagram-commandLineWidth": "Šířka čáry",
        "dxDiagram-commandLineStyle": "Styl čáry",
        "dxDiagram-commandLineStyleSolid": "Plná",
        "dxDiagram-commandLineStyleDotted": "Tečkovaná",
        "dxDiagram-commandLineStyleDashed": "Čárkovaná",
        "dxDiagram-commandFillColor": "Barva výplně",
        "dxDiagram-commandAlignLeft": "Zarovnat vlevo",
        "dxDiagram-commandAlignCenter": "Zarovnat na střed",
        "dxDiagram-commandAlignRight": "Zarovnat vpravo",
        "dxDiagram-commandConnectorLineType": "Typ čáry",
        "dxDiagram-commandConnectorLineStraight": "Přímá",
        "dxDiagram-commandConnectorLineOrthogonal": "Lomená",
        "dxDiagram-commandConnectorLineStart": "Tvar na začátku",
        "dxDiagram-commandConnectorLineEnd": "Tvar na konci",
        "dxDiagram-commandConnectorLineNone": "Žádná",
        "dxDiagram-commandConnectorLineArrow": "Šipka",
        "dxDiagram-commandFullscreen": "Celá obrazovka",
        "dxDiagram-commandUnits": "Jednotky",
        "dxDiagram-commandPageSize": "Velikost stránky",
        "dxDiagram-commandPageOrientation": "Orientace stránky",
        "dxDiagram-commandPageOrientationLandscape": "Na výšku",
        "dxDiagram-commandPageOrientationPortrait": "Na šířku",
        "dxDiagram-commandPageColor": "Barva stránky",
        "dxDiagram-commandShowGrid": "Zobrazit mřížku",
        "dxDiagram-commandSnapToGrid": "Přichytit k mřížce",
        "dxDiagram-commandGridSize": "Velikost mřížky",
        "dxDiagram-commandZoomLevel": "Měřítko",
        "dxDiagram-commandAutoZoom": "Automaticky",
        "dxDiagram-commandFitToContent": "Přizpůsobit obsahu",
        "dxDiagram-commandFitToWidth": "Přizpůsobit šířce",
        "dxDiagram-commandAutoZoomByContent": "Automaticky přizpůsobovat obsahu",
        "dxDiagram-commandAutoZoomByWidth": "Automaticky přizpůsobovat šířce",
        "dxDiagram-commandSimpleView": "Jednoduché zobrazení",
        "dxDiagram-commandCut": "Vyjmout",
        "dxDiagram-commandCopy": "Kopírovat",
        "dxDiagram-commandPaste": "Vložit",
        "dxDiagram-commandSelectAll": "Vybrat vše",
        "dxDiagram-commandDelete": "Odstranit",
        "dxDiagram-commandBringToFront": "Přenést do popřédí",
        "dxDiagram-commandSendToBack": "Přenést do pozadí",
        "dxDiagram-commandLock": "Zamknout",
        "dxDiagram-commandUnlock": "Odemknout",
        "dxDiagram-commandInsertShapeImage": "Vložit obrázek...",
        "dxDiagram-commandEditShapeImage": "Změnit obrázek...",
        "dxDiagram-commandDeleteShapeImage": "Odstranit obrázek",
        "dxDiagram-commandLayoutLeftToRight": "Zleva-do-prava",
        "dxDiagram-commandLayoutRightToLeft": "Zprava-do-leva",
        "dxDiagram-commandLayoutTopToBottom": "Zhora-dolů",
        "dxDiagram-commandLayoutBottomToTop": "Zdola-nahoru",

        "dxDiagram-unitIn": "in",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",

        "dxDiagram-dialogButtonOK": "Ok",
        "dxDiagram-dialogButtonCancel": "Zrušit",
        "dxDiagram-dialogInsertShapeImageTitle": "Vložit obrázek",
        "dxDiagram-dialogEditShapeImageTitle": "Změnit obrázek",
        "dxDiagram-dialogEditShapeImageSelectButton": "Vyberte obrázek",
        "dxDiagram-dialogEditShapeImageLabelText": "nebo přetáhněte soubor zde",

        "dxDiagram-uiExport": "Export",
        "dxDiagram-uiProperties": "Vlastnosti",
        "dxDiagram-uiSettings": "Nastavení",
        "dxDiagram-uiShowToolbox": "Zobrazit panel nástrojů",
        "dxDiagram-uiSearch": "Hledat",
        "dxDiagram-uiStyle": "Styl",
        "dxDiagram-uiLayout": "Rozvržení",
        "dxDiagram-uiLayoutTree": "Strom",
        "dxDiagram-uiLayoutLayered": "Organizace",
        "dxDiagram-uiDiagram": "Diagram",
        "dxDiagram-uiText": "Text",
        "dxDiagram-uiObject": "Objekt",
        "dxDiagram-uiConnector": "Konektor",
        "dxDiagram-uiPage": "Stránka",

        "dxDiagram-shapeText": "Text",
        "dxDiagram-shapeRectangle": "Obdélník",
        "dxDiagram-shapeEllipse": "Elipsa",
        "dxDiagram-shapeCross": "Kříž",
        "dxDiagram-shapeTriangle": "Trojúhelník",
        "dxDiagram-shapeDiamond": "Diamant",
        "dxDiagram-shapeHeart": "Srdce",
        "dxDiagram-shapePentagon": "Pětiúhelník",
        "dxDiagram-shapeHexagon": "Šestiúhelník",
        "dxDiagram-shapeOctagon": "Osmiúhelník",
        "dxDiagram-shapeStar": "Hvězda",
        "dxDiagram-shapeArrowLeft": "Šipka vlevo",
        "dxDiagram-shapeArrowUp": "Šipka nahoru",
        "dxDiagram-shapeArrowRight": "Šipka vpravo",
        "dxDiagram-shapeArrowDown": "Šipka dolů",
        "dxDiagram-shapeArrowUpDown": "Šipka nahoru a dolů",
        "dxDiagram-shapeArrowLeftRight": "Šipka vlevo a vpravo",
        "dxDiagram-shapeProcess": "Proces",
        "dxDiagram-shapeDecision": "Rozhodnutí",
        "dxDiagram-shapeTerminator": "Ukončení",
        "dxDiagram-shapePredefinedProcess": "Podprogram",
        "dxDiagram-shapeDocument": "Dokument",
        "dxDiagram-shapeMultipleDocuments": "Dokumenty",
        "dxDiagram-shapeManualInput": "Manuální vstup",
        "dxDiagram-shapePreparation": "Příprava",
        "dxDiagram-shapeData": "Data",
        "dxDiagram-shapeDatabase": "Databáze",
        "dxDiagram-shapeHardDisk": "Pevný disk",
        "dxDiagram-shapeInternalStorage": "Interní úložiště",
        "dxDiagram-shapePaperTape": "Papírová páska",
        "dxDiagram-shapeManualOperation": "Manuální operace",
        "dxDiagram-shapeDelay": "Zpoždění",
        "dxDiagram-shapeStoredData": "Uložená data",
        "dxDiagram-shapeDisplay": "Zobrazit",
        "dxDiagram-shapeMerge": "Sloučit",
        "dxDiagram-shapeConnector": "Konektor",
        "dxDiagram-shapeOr": "Nebo",
        "dxDiagram-shapeSummingJunction": "A zároveň",
        "dxDiagram-shapeContainerDefaultText": "Kontejner",
        "dxDiagram-shapeVerticalContainer": "Vertikální kontejner",
        "dxDiagram-shapeHorizontalContainer": "Horizontální kontejner",
        "dxDiagram-shapeCardDefaultText": "Karta osoby",
        "dxDiagram-shapeCardWithImageOnLeft": "Karta s obrázkem vlevo",
        "dxDiagram-shapeCardWithImageOnTop": "Karta s obrázkem nahoře",
        "dxDiagram-shapeCardWithImageOnRight": "Karta s obrázkem vpravo",

        "dxGantt-dialogTitle": "Název",
        "dxGantt-dialogStartTitle": "Začátek",
        "dxGantt-dialogEndTitle": "Konec",
        "dxGantt-dialogProgressTitle": "Průběh",
        "dxGantt-dialogResourcesTitle": "Zdroje",
        "dxGantt-dialogResourceManagerTitle": "Správce zdrojů",
        "dxGantt-dialogTaskDetailsTitle": "Detail úkolu",
        "dxGantt-dialogEditResourceListHint": "Editovat seznam zdrojů",
        "dxGantt-dialogEditNoResources": "Žádné zdroje",
        "dxGantt-dialogButtonAdd": "Přidat",
        "dxGantt-contextMenuNewTask": "Nový úkol",
        "dxGantt-contextMenuNewSubtask": "Nový podúkol",
        "dxGantt-contextMenuDeleteTask": "Odstranit úkol",
        "dxGantt-contextMenuDeleteDependency": "Odstranit závislost",
        "dxGantt-dialogTaskDeleteConfirmation": "Odstraněním úkolu dojde také k odstranění všech podřízených úkolů. Opravdu si přejete úkol odstranit?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Opravdu si přejete odstranit závislost z úkolu?",
        "dxGantt-dialogResourcesDeleteConfirmation": "Odstraněním zdroje dojde také k jeho odstranění ze všech úkolů, ke kterým je zdroj přidělen Opravdu si přejete zdroj odstranit? Počet zdrojů: {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "Úkol, který se pokoušíte přesunout je propojen s dalším úkolem pomocí závislosti. Tato změna může způsobit konflikt mezi pravidly závislostí. Jak si přejete pokračovat?",
        "dxGantt-dialogConstraintViolationMessage": "Úkol, který se pokoušíte přesunout je propojen s dalším úkolem pomocí závislosti. Jak si přejete pokračovat?",
        "dxGantt-dialogCancelOperationMessage": "Stornovat operaci",
        "dxGantt-dialogDeleteDependencyMessage": "Odstranit závislost",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Přesunout úkol a zachovat závislost",
        "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. This change would conflict with dependency rules. How would you like to proceed?",
        "dxGantt-dialogConstraintViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. How would you like to proceed?",
        "dxGantt-dialogDeleteDependenciesMessage": "Delete the dependency relations",
        "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Move the task and keep the dependencies",
        "dxGantt-undo": "Zpět",
        "dxGantt-redo": "Znovu",
        "dxGantt-expandAll": "Rozbalit vše",
        "dxGantt-collapseAll": "Sbalit vše",
        "dxGantt-addNewTask": "Přidat nový úkol",
        "dxGantt-deleteSelectedTask": "Odstranit vybraný úkol",
        "dxGantt-zoomIn": "Přiblížit",
        "dxGantt-zoomOut": "Oddálit",
        "dxGantt-fullScreen": "Celá obrazovka",
        "dxGantt-quarter": "Q{0}",
        "dxGantt-sortingAscendingText": "Srovnat vzestupně",
        "dxGantt-sortingDescendingText": "Srovnat sestupně",
        "dxGantt-sortingClearText": "Zrušit rovnání",
        "dxGantt-showResources": "Show Resources",
        "dxGantt-showDependencies": "Show Dependencies",
        "dxGantt-dialogStartDateValidation": "Start date must be after {0}",
        "dxGantt-dialogEndDateValidation": "End date must be after {0}",

        "dxGallery-itemName": "Gallery item",

        "dxMultiView-elementAriaRoleDescription": "MultiView",
        "dxMultiView-elementAriaLabel": "Use the arrow keys or swipe to navigate between views",
        "dxMultiView-itemAriaRoleDescription": "View",
        "dxMultiView-itemAriaLabel": "{0} of {1}"
    }
}
